import Vue from 'vue';

export default {
    getBusqueda(parametros){
        return Vue.axios.get("buscador/search", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    }
}